import { lazy } from 'react';
import appRoutes from './appRoutes';
const ContactDetailsForm = lazy(
  () => import('../components/PR/ContactDetailsForm/ContactDetailsForm')
); // PR first page, patient contact detail page
const ConsentForm = lazy(() => import('../components/PR/ConsentForms/ConsentForm'));
const AddNewConsent = lazy(() => import('../components/PR/ConsentForms/AddNewConsentForm'));
const MedicalHistory = lazy(() => import('../components/PR/MedicalHistory/MedicalHistory')); // PR Medical History tab page
const ProtocolPage = lazy(() => import('../components/PR/Protocols/ProtocolTable'));
import ViewProtocol from '../components/PR/Protocols/ViewProtocol';

const AddS4DrugProtocolFrom = lazy(
  () => import('../components/PR/S4DrugProtocols/AddS4DrugProtocolForm')
); // Add S4 drug protocol form

const AddOtherProtocol = lazy(() => import('../components/PR/OtherProtocols/AddOtherProtocol')); // Add Other protocol form
const BookingPage = lazy(() => import('../pages/Booking/Booking')); // booking page
const EditBookingPage = lazy(() => import('../pages/Booking/EditBooking')); // edit booking page
const ViewBookingPage = lazy(() => import('../pages/Booking/ViewBooking')); // view booking page
const PractitionerConsentsPage = lazy(
  () => import('../pages/PractitionerConsents/PractitionerConsents')
);
const EditPractitionerConsents = lazy(
  () => import('../pages/PractitionerConsents/EditPractitionerConsents')
);
const AddPaymentPage = lazy(() => import('../pages/AddPayment')); // Nurse payment

const PRRoutes = [
  { path: `${appRoutes.prDashboard}/:id`, element: <ContactDetailsForm /> },
  { path: appRoutes.prConsentForms, element: <ConsentForm /> },
  { path: appRoutes.prAddNewConsentForm, element: <AddNewConsent /> },
  { path: appRoutes.prMedicalHistory, element: <MedicalHistory /> },
  { path: appRoutes.prProtocols, element: <ProtocolPage /> },
  { path: `${appRoutes.prViewProtocol}/:id`, element: <ViewProtocol /> },
  { path: appRoutes.prAddS4DrugProtocolForm, element: <AddS4DrugProtocolFrom /> },
  { path: appRoutes.prAddOtherProtocol, element: <AddOtherProtocol /> },
  { path: appRoutes.prPractitionerConsents, element: <PractitionerConsentsPage /> },
  { path: appRoutes.prEditPractitionerConsents, element: <EditPractitionerConsents /> },
  { path: appRoutes.prBookingHistory, element: <BookingPage /> },
  { path: appRoutes.prEditBookingHistory + '/:id', element: <EditBookingPage /> },
  { path: appRoutes.prViewBookingHistory + '/:id', element: <ViewBookingPage /> },
  { path: appRoutes.prCreateBooking, element: <EditBookingPage /> },
  { path: appRoutes.prPayment + '/:id', element: <AddPaymentPage /> },
];

export default PRRoutes;
